/** @jsx jsx */
import { jsx } from '@emotion/react';

import { ContentPage } from './content-page';
import ErrorPage from '../error-page';
import { FinalizerPage, FinalizerPageTermination } from './finalizer-page';
import { RedirecterPage } from './redirecter-page';

import css from './page.css';

import {
  PAGES__ROLE_ERROR,
  PAGES__ROLE_FINALIZER,
  PAGES__ROLE_REDIRECTER,
  PAGES__ROLE_TERMINATION_FINALIZER,
  PAGES__SHAPE_ITEM,
} from '../../redux/constants';
import { PageForm } from './form/page-form';

const getPageComponent = (role) => {
  switch (role) {
    case PAGES__ROLE_ERROR:
      return ErrorPage;
    case PAGES__ROLE_FINALIZER:
      return FinalizerPage;
    case PAGES__ROLE_REDIRECTER:
      return RedirecterPage;
    case PAGES__ROLE_TERMINATION_FINALIZER:
      return FinalizerPageTermination;
    default:
      return ContentPage;
  }
};

const Page = (props) => {
  const PageComponent = getPageComponent(props.page?.$role);
  const error = props.page?.$role === PAGES__ROLE_ERROR ? props.page.error : null;
  const errorProps = error ? { message: error.message, image: error.image } : {};
  return (
    <div css={css}>
      <PageForm {...props}>
        <PageComponent {...props} {...errorProps} />
      </PageForm>
    </div>
  );
};

Page.propTypes = {
  page: PAGES__SHAPE_ITEM,
};

Page.defaultProps = {
  page: null,
};

export default Page;
